// extracted by mini-css-extract-plugin
export default {"root":"styles_root__tcA80","team":"styles_team__T4tUt"};